import React from 'react';
import { Button, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

interface PaginationControlsProps {
  pageStart: number;
  pageEnd: number;
  totalItems: number;
  onPageLeft: () => void;
  onPageRight: () => void;
  disabled?: boolean;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  pageStart,
  pageEnd,
  totalItems,
  onPageLeft,
  onPageRight,
  disabled = false,
}) => {
  return (
    <Row>
      <div className={'w-100'} style={{ textAlign: 'right' }}>
        <div>
          <Button
            disabled={disabled || pageStart === 0}
            className={'btn-sm mr-2 cursor-pointer'}
            onClick={onPageLeft}
          >
            <FontAwesomeIcon className={'icon'} icon={faArrowLeft} />
          </Button>
          <div className={'d-inline-block ml-1'}>{pageStart + 1}</div>
          <div className={'d-inline-block ml-1'}>to</div>
          <div className={'d-inline-block ml-1 mr-1'}>{Math.min(pageEnd, totalItems)}</div>
          <div className={'d-inline-block ml-1 mr-1'}>of {totalItems}</div>
          <Button
            disabled={disabled || pageEnd >= totalItems}
            className={'btn-sm mr-2 cursor-pointer ml-2'}
            onClick={onPageRight}
          >
            <FontAwesomeIcon className={'icon'} icon={faArrowRight} />
          </Button>
        </div>
      </div>
    </Row>
  );
};

export default PaginationControls;
